export const SPECIAL_COLUMN = {
  mobile: '移动端',
  PC: 'PC端',
  total: '总计',
}